import { Route } from "react-router-dom";
import AreaManagerDashboard from "../../screens/area_manager/AreaManagerDashboard";
import AddVLE from "../../screens/area_manager/AddVLE";
import VLEList from "../../screens/area_manager/VLEList";
import ProgramList from "../../screens/programs/ProgramList";
import ProgramDetails from "../../screens/program_manager/ProgramDetails";
import VLETarget from "../../screens/area_manager/VLETarget";
import BiocharOrderList from "../../screens/area_manager/BiocharOrderList";
import BiocharOrderPlace from "../../screens/area_manager/BiocharOrderPlace";
import ProcurementList from "../../screens/biochar/ProcurementList";
import ProcurementScheduleInspection from "../../screens/biochar/ProcurementScheduleInspection";
import ProcurementInspection from "../../screens/biochar/ProcurementInspection";
import ProcurementDetail from "../../screens/biochar/ProcurementDetail";
import PickupOrders from "../../screens/biochar/PickupOrders";
import CreatePickupOrder from "../../screens/biochar/CreatePickupOrder";
import ManagePickupOrder from "../../screens/biochar/ManagePickupOrder";
import ProcurementPickup from "../../screens/biochar/ProcurementPickup";
import PickupOrderExpenseTracker from "../../screens/area_manager/PickupOrderExpenseTracker";
import ProcurementPickupRequest from "../../screens/biochar/ProcurementPickupRequest";

export const areaManagerRoutes = [
  <Route key="area-manager-home" path="/" element={<AreaManagerDashboard />} />,
  <Route
    key="area-manager-vle-add"
    path="/area-manager/vle/add"
    element={<AddVLE />}
  />,
  <Route
    key="area-manager-vles"
    path="/area-manager/vles"
    element={<VLEList />}
  />,
  <Route
    key="area-manager-programs"
    path="/area-manager/programs"
    element={<ProgramList />}
  />,
  <Route
    key="program-details"
    path="/program/:programId"
    element={<ProgramDetails />}
  />,
  <Route
    key="area-manager-vle-target"
    path="/area-manager/vle/:vleid"
    element={<VLETarget />}
  />,
  <Route
    key="biochar-orders-list"
    path="/biochar-orders-list"
    element={<BiocharOrderList />}
  />,
  <Route
    key="biochar-order-place"
    path="/biochar-order/place-order"
    element={<BiocharOrderPlace />}
  />,
  <Route
    key="procurement-list"
    path="/procurement-list"
    element={<ProcurementList />}
  />,
  <Route
    key="procurement-schedule-inspection"
    path="/procurement/schedule-inspection/:id"
    element={<ProcurementScheduleInspection />}
  />,
  <Route
    key="procurement-inspection"
    path="/procurement/inspection/:id"
    element={<ProcurementInspection />}
  />,
  <Route
    key="procurement-pickup-request"
    path="/procurement/pickup-request/:id"
    element={<ProcurementPickupRequest />}
  />,
  <Route
    key="procurement-detail"
    path="/procurement/:id"
    element={<ProcurementDetail />}
  />,
  <Route
    key="pickup-orders"
    path="/pickup-orders"
    element={<PickupOrders />}
  />,
  <Route
    key="create-pickup-order"
    path="/create-pickup-order"
    element={<CreatePickupOrder />}
  />,
  <Route
    key="pickup-order-detail"
    path="/pickup-order/:id"
    element={<ManagePickupOrder />}
  />,
  <Route
    key="procurement-pickup"
    path="/procurement/pickup/:id"
    element={<ProcurementPickup />}
  />,
  <Route
    key="pickup-order-expense-tracker"
    path="/pickup-order-expense-tracker"
    element={<PickupOrderExpenseTracker />}
  />,
];
